import React, { useState } from 'react';

const credentials = [
  {
    name: 'AHCS',
    fullName: 'Academy for Healthcare Science',
    url: 'https://www.ahcs.ac.uk/',
    logo: '/ahcs-logo.svg',
  },
  {
    name: 'CEP-UK',
    fullName: 'Clinical Exercise Physiology UK',
    url: 'https://www.clinicalexercisephysiology.org.uk/',
    logo: '/CEP_final.avif',
  },
];

const CredentialLogos: React.FC = () => {
  return (
    <div className="credential-logos" role="complementary" aria-label="Professional accreditation">
      <div className="container">
        <p className="credential-logos-label">Registered with</p>
        <div className="credential-logos-list">
          {credentials.map((cred) => (
            <CredentialItem key={cred.name} cred={cred} />
          ))}
        </div>
      </div>
    </div>
  );
};

const CredentialItem: React.FC<{ cred: (typeof credentials)[0] }> = ({ cred }) => {
  const [useLogo, setUseLogo] = useState(true);
  return (
    <a
      href={cred.url}
      target="_blank"
      rel="noopener noreferrer"
      className="credential-logos-item"
      title={cred.fullName}
    >
      {useLogo ? (
        <img
          src={cred.logo}
          alt={`${cred.name} logo`}
          className="credential-logos-img"
          onError={() => setUseLogo(false)}
        />
      ) : (
        <span className="credential-logos-text">{cred.name}</span>
      )}
    </a>
  );
};

export default CredentialLogos;
